import {
  checkStatus,
  getHeaders
} from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { useContext } from "react";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

const baseURL = process.env.REACT_APP_BASE_URL;


export default function DashboardServices(params, component) {
   const toster = useContext(TostMsg);
  var url = "https://jsonplaceholder.typicode.com/comments";
  fetch(url, {
      method: "GET",
      headers: new Headers({}),
    })
    .then((response) => response.json())
    .then((json) => {
      toster.current.error(ERROR_LIST.DefaultError);
})
    .catch((error) => {
      return Promise.reject(error);
    });
}

// For fetching the record of Feed service. 

export const getFeed = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Feed`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getFeaturedPostFeed = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Featured`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postMarkFeatured = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/MarkFeatured`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const postMarkUnFeatured = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Featured/UnFeatured?PostId=${body?.PostId}`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getPopularPostFeed = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Feed/Popular`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For post the record of Feed service. 

export const postFeed = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For update the record of Feed service. 

export const updateFeed = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Update`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


// For allows users to like a particular story posted by their friends or other accounts they follow. 
export const feedLikePost = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Like`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


// For Delete the post of Feed service.

export const deleteFeedPost = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Comment, This feature allows you to respond to comments and messages directly from the story. 

export const feedPostComment = async (body) => { 
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Comment`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const feedPostCommentDelete = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Comment/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const feedPostReport = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Report`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const feedReportDelete = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Report/Delete`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const feedCommentList = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Comment/List`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const feedLikeList = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Like/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const feedPostFeatures = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Features`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Post feature post records service.

export const convertToFeaturePost = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Features`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For Report feature post service.

export const getReportPost = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Feed/Post/Report`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
// For Report feature post service.
export const postEmployeeFollow = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Follow`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
// For Get feed count 
export const getFeedCount = async (body) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Feed/FeedCount?EmpId=${body?.EmpId}&OrgId=${body?.OrgId}`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const getOrganisationDetails = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Org/Details`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const updateOrgDetails = async (body) => {
  try{
    const response = await axiosInstance.post(`${baseURL}/Org/Update`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}